import '../../styles/rfiElements.css';
import React from 'react';
import { isEqual } from 'lodash';
import { IElementProps } from 'types/RfiTypes';

const GuidanceText = (props: IElementProps) => {
  return (
    <>
      <div>
        <p className="guidance-text">{props.element.fieldLabel}</p>
      </div>
    </>
  );
};

const areEqual = (prevProps: IElementProps, nextProps: IElementProps) => {
  return (
    isEqual(prevProps.element, nextProps.element) &&
    isEqual(prevProps.designMode, nextProps.designMode)
  );
};

const GuidanceTextElement = React.memo(GuidanceText, areEqual);

export default GuidanceTextElement;
